import { useState, useCallback } from 'react';

/**
 * Custom hook for managing accordion state
 * Provides generic toggle and check functions for multiple accordion instances
 * 
 * @returns {object} Object containing toggleAccordion and isAccordionOpen functions
 */
const useAccordion = () => {
  const [openAccordions, setOpenAccordions] = useState({});

  // Generic toggle function for all accordions
  const toggleAccordion = useCallback((category, index) => {
    const key = `${category}-${index}`;
    setOpenAccordions(prev => ({
      ...prev,
      [key]: prev[key] ? null : key
    }));
  }, []);

  // Helper to check if accordion is open
  const isAccordionOpen = useCallback((category, index) => {
    const key = `${category}-${index}`;
    return openAccordions[key] === key;
  }, [openAccordions]);

  return {
    toggleAccordion,
    isAccordionOpen
  };
};

export default useAccordion;

